// src/services/passwordService.js

import { logEvent } from './log.service';
import { revokeTokens } from './ccs.user.servic';
import {
  changePasswordCognito,
  getCognitoAccessToken,
  isCognitoAccessTokenExpired,
} from './cognito.service';
import { isArobaTokenExpired } from './aroba.service';
import { refreshTokens } from './token.service';
import { HistoryCode } from '@/globals/enums';

export const changePassword = async (currentPassword, newPassword) => {
  try {
    // check token expiration
    const tokensValid = await checkTokenExpiration();
    if (!tokensValid) {
      throw new Error('Tokens are expired and could not be refreshed');
    }

    // change password in Cognito
    await changePasswordCognito(currentPassword, newPassword);

    try {
      await logEvent(HistoryCode.ChangePassword);
      await logEvent(HistoryCode.Logout);
    } catch (error) {
      console.error('Failed to log password change event:', error);
    }

    // revoke tokens
    let revokeSuccess = false;
    for (let i = 0; i < 2; i++) {
      try {
        const cognitoAccessToken = await getCognitoAccessToken();
        const response = await revokeTokens(cognitoAccessToken, 0);
        if (response.code === 0 && !response.error) {
          revokeSuccess = true;
          break;
        }
      } catch (error) {
        console.error('Failed to revoke tokens:', error);
      }
    }

    if (!revokeSuccess) {
      console.warn('Failed to revoke tokens after 2 attempts');
    }
  } catch (error) {
    console.error('Password change failed:', error);
    throw error;
  }
};

const checkTokenExpiration = async () => {
  try {
    if (isArobaTokenExpired() || (await isCognitoAccessTokenExpired())) {
      // attempt to refresh tokens
      try {
        await refreshTokens();
        return true;
      } catch (error) {
        console.error('Failed to refresh tokens:', error);
        return false;
      }
    }

    return true;
  } catch (error) {
    console.error('Failed to check token expiration:', error);
    return false;
  }
};
